import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IconsService } from 'src/app/shared/services/icons.service';

@Component({
  selector: '[app-tr-zonas]',
  template: `
    <td class="align-middle">{{zona?.name}}</td>
    <td class="align-middle">{{zona?.description}}</td>
    <td class="align-middle text-end">
      <button type="button" class="btn btn-sm p-0 btn-link" routerLink="{{zona?.id}}">
        <fa-icon [icon]="icons.faEdit"></fa-icon>
      </button>
    </td>
  `,
  styles: ``
})
export class TrZonasComponent {
  @Input() zona: any;
  @Input() profile: any;
  @Input() permissions: any;
  @Output() refuelSelected = new EventEmitter<any>();

  constructor(
    public icons: IconsService
  ) { }
}
